import styled from 'styled-components';

const OutletChainStyled = styled.div`
`;
export default OutletChainStyled;
